import React, { Component } from 'react'
import dateFormat from '../../lib/utils/dateformat'
import classNames from 'classnames'
export default class DatePickerV2 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      date: null,
      activeDate : null,
      today: null,
      month: null,
      year: null,
      open: false,
      oneDay: 86400000
    }

    this.showCalendar = this.showCalendar.bind(this)
    this.hide = this.hide.bind(this)
    this.show = this.show.bind(this)
    this.selectDate = this.selectDate.bind(this)
    this.onClickToday = this.onClickToday.bind(this)
    this.buildDayNodes = this.buildDayNodes.bind(this)
  }

  /**
  * Intial load so add the date to the state for use and manipulation
  *
  * @returns {undefined} undefined
  **/
  componentWillMount() {
    this.updateState(this.props)
  }

  /**
  * Parent may have changed date property so lets compare and set state
  * if required
  *
  * @param {Object} nextProps new props
  * @returns {undefined} undefined
  **/
  componentWillReceiveProps(nextProps) {
    let oDate = dateFormat.dateToObject(nextProps.date) || new Date()
    let iDate = oDate.setHours(0, 0, 0, 0)
    let currDate = this.props.date || new Date()
    let iCurrDate = dateFormat.dateToObject(currDate).setHours(0, 0, 0, 0)
    //check if dates are changed and update accordingly
    if (iDate != iCurrDate) {
      this.updateState(nextProps)
    }
  }

  /**
  * Checks the prop for a date, if none found it sets it to today, also
  * sets the current month and year. Makes sure all dates are set to
  * midnight
  *
  * @param {Object} oProps props
  * @returns {undefined} undefined
  **/
  updateState(oProps) {
    let oDate = dateFormat.dateToObject(oProps.date) || new Date()
    let iDate = oDate.setHours(0, 0, 0, 0)
    let iMonth = new Date(iDate).setDate(1)
    let iToday = new Date().setHours(0, 0, 0, 0)
    let iYear = new Date(iDate).getFullYear()
    let iActiveDate = dateFormat.dateToObject(oProps.activeDate || new Date()).setHours(0,0,0,0)
    this.setState({
      date: iDate,
      activeDate : iActiveDate,
      today: iToday,
      month: iMonth,
      year: iYear
    })
  }
  /**
  * Moves the current view month forward by 1
  * @param {string} type type of event
  * @param {Object} e event object
  * @returns {undefined} undefined
  **/
  next(type, e) {
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    let oMonth = dateFormat.dateToObject(this.state.month)
    let iMonth = oMonth.getMonth()
    let iYear = oMonth.getFullYear()
    if (type == 'year') {
      iYear += 1
    }
    if (type == 'month') {
      if (iMonth > 10) {
        iMonth = 0
        iYear++
      } else {
        iMonth += 1
      }
    }

    oMonth = new Date(iYear, iMonth, 1)
    this.setState({
      month: oMonth.getTime()
    })

  }

  /**
* Moves the current view month back by 1
* @param {String} type type of action whether month/year
* @param {Object} e event object
* @returns {undefined} undefined
**/
  prev(type, e) {

    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    let oMonth = dateFormat.dateToObject(this.state.month)
    let iMonth = oMonth.getMonth()
    let iYear = oMonth.getFullYear()
    if (type == 'year') {
      iYear -= 1
    }
    if (type == 'month') {
      if (iMonth < 0) {
        iMonth = 0
        iYear--
      } else {
        iMonth -= 1
      }
    }
    oMonth = new Date(iYear, iMonth, 1)
    this.setState({
      month: oMonth.getTime()
    })

  }
  /**
  * Toggles the state to show or hide the calendar dropdown.
  *
  * @returns {undefined} undefined
  **/
  showCalendar() {
    if (this.state.open) {
      this.hide()
    } else {
      this.show()
    }
  }

  // show calender and attach a listener to document to hide if clicked anywhere else
  show() {
    document.addEventListener('click', this.hide)
    this.updateState(this.props)
    this.setState({
      open: true
    })
  }

  //hide calender and remove listener
  hide() {
    document.removeEventListener('click', this.hide)
    this.setState({
      open: false
    })
  }
  /**
   * selects a date and triggers a callback
   * @param {date} iDate date
   * @return {undefined} undefined 
   */
  selectDate(iDate) {
    let type = this.props.type
    let selectedDate
    if (typeof this.props.callback == 'function') {
      selectedDate = dateFormat.dateFormat(iDate, type == 'month' ? 'date19' : 'date12')
      this.props.callback(dateFormat.dateToObject(iDate), selectedDate)
    }
  }

  // handler for today's click
  onClickToday() {
    this.selectDate(this.state.today)
  }

  buildMonthNodes() {
    let iActiveDate = this.state.activeDate
    let iMonth = this.state.month
    let oDate = dateFormat.dateToObject(iMonth)
    //let month = oDate.getMonth()
    let year = oDate.getFullYear()
    let monthNames = dateFormat.monthNamesLong()
    let monthRows = []
    let oActiveDate = dateFormat.dateToObject(iActiveDate)

    for (let i = 0; i < 12; i++) {
      let oCurrMonth = dateFormat.dateToObject(`${year}-${i > 8 ? i + 1 : '0' + (i + 1)}-01T00:00:00`)
      let iCurrMonth = oCurrMonth.setHours(0, 0, 0, 0)
      let props = {
        key: iCurrMonth,
        onClick: this.selectDate.bind(this, iCurrMonth)
      }
      let liClass = [ 'DateCarousel__list__item' ]
      if (oActiveDate.getMonth() == i && oActiveDate.getFullYear() == year) {
        liClass.push('is-active')
        props.style = { maxWidth: 'none' }
      } else {
        liClass.push('has-event')
      }
      monthRows.push(
        <li {...props} className={classNames(liClass)}>
          <div className="DateCarousel__day" style={{ fontSize: 'inherit' }}>
            <span className="DateCarousel__dayNum">
              {monthNames[i]}
            </span>
            <span className="DateCarousel__dayName" style={{ color: 'inherit' }}>
              {year}
            </span>
          </div>
        </li>
      )
    }
    return (
      <ul className="MonthContainer__weekList">
        {monthRows}
      </ul>
    )
  }
  // frame markup for date nodes
  buildDayNodes() {
    let iDate = this.state.activeDate
    let iToday = this.state.today
    let iMonth = this.state.month
    //let oActiveDates    = this.props.activeDates || {}

    /* Calculate first date */
    let iStartDay = iMonth - (dateFormat.dateToObject(iMonth).getDay() * this.state.oneDay)

    let aRows = []
    for (let iWeeks = 0; iWeeks < 6; iWeeks++) {
      let aDays = []
      //today old new active
      for (let iDays = 0; iDays < 7; iDays++) {

        let aDayClass = [ 'MonthContainer__day' ]
        let props = {
          key: iDays,
          onClick: this.selectDate.bind(this, iStartDay)
        }

        if (iToday === iStartDay && iToday !== iDate) {
          aDayClass.push('MonthContainer__day--today')
        }

        if (iDate === iStartDay) {
          aDayClass.push('MonthContainer__day--selected')
        }

        // TODO: Highlight active game dates when available in the future(as of now all dates are active)
        /*if(!oActiveDates[iStartDay]) {
          aDayClass.push('MonthContainer__day--noEvent')
        }*/

        if (dateFormat.dateToObject(iMonth).getMonth() !== dateFormat.dateToObject(iStartDay).getMonth()) {
          aDayClass.push('MonthContainer__day--out')
        }

        props.className = classNames(aDayClass)
        aDays.push(
          <li {...props}>{dateFormat.dateToObject(iStartDay).getDate()}</li>
        )

        iStartDay = iStartDay + this.state.oneDay
      }
      aRows.push(
        <ul className="MonthContainer__week" key={iWeeks}>{aDays}</ul>
      )
    }

    return aRows
  }
  render() {
    let open = this.state.open
    let iMonth = this.state.month
    let pickerClass = 'DatePicker__MonthContainer'
    let today = this.state.today
    let date = this.state.date
    let type = this.props.type
    let dayNodes = ''
    let monthNodes = ''
    let dayNames = []
    let dayNamesMrkp
    let heading = ''
    let nowButtonText
    let nowButtonClass = [ 'button', 'MonthContainer__button' ]
    let isTodayActive
    if (type == 'day') {
      dayNames = dateFormat.dateDayNamesXShort()
      dayNamesMrkp = dayNames.map((day, i) => {
        return (<span className="MonthContainer__dayNames" key={`w${i}`}>{day}</span>)
      })
      dayNodes = this.buildDayNodes()
      heading = dateFormat.dateFormat(iMonth, 'date11')
      nowButtonText = 'NOW'
      isTodayActive = date == today
    } else {
      heading = dateFormat.dateToObject(iMonth).getFullYear()
      monthNodes = this.buildMonthNodes()
      nowButtonText = 'THIS MONTH'
      isTodayActive = dateFormat.dateFormat(today, 'date19') == dateFormat.dateFormat(date, 'date19')
    }
    if (open) {
      pickerClass += ' is-active'
    }
    if(isTodayActive) {
      nowButtonClass.push('disabled')
    }
    return (
      <div>
        <button className="DateCarousel__MonthTrigger" onClick={this.showCalendar}></button>
        <div className={pickerClass}>
          <div className="MonthContainer__header">
            <button className="carousel__arrow carousel__arrow--year carousel__arrow--left"
              onClick={this.prev.bind(this, 'year')}></button>
            {
              type == 'day' ?
                <button className="carousel__arrow carousel__arrow--month carousel__arrow--left"
                  onClick={this.prev.bind(this, 'month')}></button> : null
            }
            <div className="MonthContainer__monthYear">{heading}</div>
            {
              type == 'day' ?
                <button className="carousel__arrow carousel__arrow--month carousel__arrow--right"
                  onClick={this.next.bind(this, 'month')}></button> : null
            }
            <button className="carousel__arrow carousel__arrow--year carousel__arrow--right"
              onClick={this.next.bind(this, 'year')} ></button>
          </div>
          {
            type == 'day' ?
              <div className="MonthContainer__week MonthContainer__week__dayNames" >
                {dayNamesMrkp}
              </div> : null
          }
          {
            type == 'day' ? dayNodes : monthNodes
          }
          <div className="MonthContainer__buttonContainer">
            <button
              className={classNames(nowButtonClass)}
              onClick={this.onClickToday}
              disabled={isTodayActive}
              style={{ borderWidth : '0px' }}>
              {nowButtonText}
            </button>
            <button className="button MonthContainer__button" onClick={this.showCalendar}>Cancel</button>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../app/components/common/DatePickerV2.jsx